



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Loader from '@/components/ui/Loader.vue'
import '@/icons/slider'

@Component({
  components: {
    Loader
  }
})
export default class CompareSlider extends Vue {
  public $refs!: {
    scrubber: HTMLElement
    slider: HTMLElement
    overlay: HTMLElement
  }
  @Prop({ default: '' }) private back!: string
  @Prop({ default: '' }) private cover!: string
  private buttonWidth: number = 80
  private current: number = 50
  private isDragging: boolean = false
  private max: number = 100
  private maxPosition: number = 0
  private min: number = 0
  private minPosition: number = 0
  private offset: number = 0
  private percentage: number = 0
  private publicPath: string = process.env.BASE_URL
  private sliderWidth: number = 0
  private sliderHeight: number = 0
  private value: number = 0
  private isFrontLoaded = false
  private isBackLoaded = false
  private isLoading = true
  private zoom: number = 1

  public forceUpdate () {
    this.getSize()
    this.getOffset()
    this.init()
    this.bindEvents()
  }

  @Watch('back')
  private onBackChanged (val: string, oldVal: string) {
    if (!this.isVideo(val)) {
      this.isLoading = true
      this.isBackLoaded = false
    }
  }

  @Watch('front')
  private onFronthanged (val: string, oldVal: string) {
    if (!this.isVideo(val)) {
      this.isLoading = true
      this.isFrontLoaded = false
    }
  }

  private mounted () {
    this.forceUpdate()
  }

  private frontLoaded () {
    this.isFrontLoaded = true
    this.checkLoaded()
  }

  private backLoaded () {
    this.isBackLoaded = true
    this.checkLoaded()
  }

  private checkLoaded () {
    if (this.isBackLoaded && this.isFrontLoaded) {
      this.isLoading = false
    }
  }

  private isVideo (filename: string) {
    return /\.mp4$/i.test(filename)
  }

  private getSize () {
    const str = document.documentElement.style.zoom || '1'
    this.zoom = +str
    this.buttonWidth = this.$refs.scrubber.clientWidth

    this.sliderWidth = this.$refs.slider.clientWidth
    this.sliderHeight = this.$refs.slider.clientHeight
    this.minPosition = -((this.buttonWidth / 2) * this.zoom)
    this.maxPosition = (this.sliderWidth * this.zoom) - ((this.buttonWidth * this.zoom) / 2)
  }

  private getOffset () {
    const rect = this.$refs.slider.getBoundingClientRect()
    this.offset = rect.left * this.zoom
  }

  private beforeDestroy () {
    this.unBindEvents()
  }

  private bindEvents () {
    document.addEventListener('touchmove', this.dragMove, { passive: false })
    document.addEventListener('touchend', this.dragUp, { passive: false })
    this.$refs.scrubber.addEventListener('touchstart', this.dragDown, { passive: false })
    this.$refs.scrubber.addEventListener('mousedown', this.dragDown)
    document.addEventListener('mousemove', this.dragMove)
    document.addEventListener('mouseup', this.dragUp)
    document.addEventListener('mouseleave', this.dragUp)
    window.addEventListener('resize', this.onResize)
  }

  private unBindEvents () {
    document.removeEventListener('touchmove', this.dragMove)
    document.removeEventListener('touchend', this.dragUp)
    this.$refs.scrubber.removeEventListener('touchstart', this.dragDown)
    this.$refs.scrubber.removeEventListener('mousedown', this.dragDown)
    document.removeEventListener('mousemove', this.dragMove)
    document.removeEventListener('mouseup', this.dragUp)
    document.removeEventListener('mouseleave', this.dragUp)
    window.removeEventListener('resize', this.onResize)
  }

  private onResize () {
    this.getSize()
    this.getOffset()
    this.setValue(this.percentage)
  }

  private dragDown (e: MouseEvent | TouchEvent) {
    this.getSize()
    this.getOffset()
    this.isDragging = true
    this.dragMove(e)
  }

  private dragMove (e: MouseEvent | TouchEvent) {
    const event = 'targetTouches' in e ? e.targetTouches[0] : e
    if (this.isDragging) {
      const xpos = event.pageX
      const xposFixed = xpos - this.offset
      let absoluteXPercentage = (xposFixed / (this.sliderWidth * this.zoom)) * 100
      if (absoluteXPercentage < 0) {
        absoluteXPercentage = 0
      }
      if (absoluteXPercentage > 100) {
        absoluteXPercentage = 100
      }
      this.setValue(absoluteXPercentage)
    }
  }

  private dragUp () {
    this.isDragging = false
  }

  private setValue (percentage: number) {
    if (percentage < 0) {
      percentage = 0
    }
    if (percentage > 100) {
      percentage = 100
    }
    this.percentage = percentage
    this.$refs.scrubber.style.left = 'calc(' + this.percentage + '% - ' + ((this.buttonWidth) / 2) + 'px)'
    this.value = this.min + (this.max - this.min) * (percentage / 100)
  }

  private init () {
    const percentage = (this.current - this.min) * 100 / (this.max - this.min)
    this.setValue(percentage)
  }
}
